import * as z from 'zod';

import { inventoryKitItemQuerySchema } from './inventory-kit-item-query-schema';

export const inventoryKitItemMutationSchema = inventoryKitItemQuerySchema
  .pick({
    id: true,
    inventory_id: true,
    quantity: true,
    sort_order: true,
  })
  .extend({
    inventory_kit_id: z.number().nullable(),
  });

export type InventoryKitItemMutationSchema = z.infer<typeof inventoryKitItemMutationSchema>;

export const inventoryKitItemCreateMutationSchema = inventoryKitItemMutationSchema.omit({ id: true });

export type InventoryKitItemCreateMutationSchema = z.infer<typeof inventoryKitItemCreateMutationSchema>;
